(function (upp) {
    'use strict';

    var tabs = {
        "CONTACT": {
            url: "/about/contact"
        },
        "WHO": {
            url: "/about/who"
        },
        "LOCATION": {
            url: "/about/where"
        },
        SOCIAL_NETWORK: {
            url: "/about/rrss"
        },
        "POLICY": {
            url: "/about/policy"
        }
    };

    /**
     * Load the root scope needed info to the about view.
     * @param appi
     * @param aboutService
     * @param $rootScope
     * @param $scope
     * @param $q
     * @returns {*} promise
     */
    function loadRootScope(appi, aboutService, $rootScope, $scope, $q, translator) {
        var deferred = $q.defer();
        var promise = deferred.promise;
        var sections = [];
        if ($rootScope.info) {
            // transform info to scope and set actual tab
            $rootScope.info.forEach(function (item) {
                var result = {
                    url: tabs[item.type].url,
                    active: false,
                    type: item.type,
                    name: item.name ? item.name : translator.i18n('ABOUT.INFO.' + item.type.toUpperCase())
                };
                sections.push(result);
            });
            $scope.navbar = sections;
            appi.ui.hidePageLoadingMsg();
            // Simulate resolving of promise  with success
            deferred.resolve();
        } else {
            aboutService.getInfo()
                .then(function (info) {
                    $rootScope.info = info;
                    // transform info to scope and set actual tab
                    $rootScope.info.forEach(function (item) {
                        var result = {
                            url: tabs[item.type].url,
                            active: false,
                            type: item.type,
                            name: item.name ? item.name : translator.i18n('ABOUT.INFO.' + item.type.toUpperCase())
                        };
                        sections.push(result);
                    });
                    $scope.navbar = sections;
                    appi.ui.hidePageLoadingMsg();
                    // resolve
                    deferred.resolve();
                }, function () {
                    appi.ui.showNetworkError();
                    deferred.reject();
                });
        }
        return promise;
    }

    /**
     * Select the correct object of JSON that is equal of the key
     * @param info
     * @param key
     * @returns {undefined} or result
     **/
    function getSection(info, key) {
        var result = undefined;
        info.every(function (item) {
            if (item.type === key) {
                if (key === "SOCIAL_NETWORK" && item.socialNetworks != undefined) {
                    var i, len;
                    len = item.socialNetworks.length;
                    for (i = 0; i < len; i++) {
                        var sn = item.socialNetworks[i];
                        if (sn.idSocialNetwork === 12) {
                            item.socialNetworks[i].url = 'skype:' + sn.url + '?call';
                        }
                    }
                }
                result = item;
                return false;
            }
            return true;
        });
        return result;
    }

    /**
     * Put the ActiveSection in AboutTabs
     * @param $scope
     * @param key
     */
    function setActiveSection($scope, key) {
        $scope.navbar.map(function (item) {
            if (item.type === key) {
                item.active = true;
            }
        });
    }

    //Controller for template "/about/about.html", url "/about/"
    upp.controller('upp.about.InfoCtrl', ['$q', '$rootScope', '$scope', '$location', 'appi', 'aboutService', 'translator',
        function ($q, $rootScope, $scope, $location, appi, aboutService, translator) {
            appi.ui.changeActualOption({moduleKey2Display: 'about', navbarKey: 'about'});
            appi.ui.showPageLoadingMsg();

            loadRootScope(appi, aboutService, $rootScope, $scope, $q, translator).then(function () {
                $location.path(tabs[$rootScope.info[0].type].url).replace();
            })
        }]);

    //Controller for template "/about/about-rrss.html", url "/about/rrss"
    upp.controller('upp.about.RrssCtrl', ['$q', '$rootScope', '$scope', '$location', 'appi', 'aboutService', 'translator', 'urlResolver',
        function ($q, $rootScope, $scope, $location, appi, aboutService, translator, urlResolver) {
            appi.ui.changeActualOption({moduleKey2Display: 'about', navbarKey: 'about'});
            loadRootScope(appi, aboutService, $rootScope, $scope, $q, translator).then(function () {
                $scope.rrss = getSection($rootScope.info, 'SOCIAL_NETWORK');
                if ($scope.rrss.socialNetworks == undefined) {
                    $scope.isEmpty = true;
                }
                setActiveSection($scope, 'SOCIAL_NETWORK');
            });
            $scope.openUrl = (url) => urlResolver.open(url);
        }]);

    //Controller for template "/about/about-who.html", url "/about/who"
    upp.controller('upp.about.WhoCtrl', ['$q', '$rootScope', '$scope', '$location', '$sce', 'appi', 'aboutService', 'translator',
        function ($q, $rootScope, $scope, $location, $sce, appi, aboutService, translator) {
            appi.ui.changeActualOption({moduleKey2Display: 'about', navbarKey: 'about'});
            loadRootScope(appi, aboutService, $rootScope, $scope, $q, translator).then(function () {
                $scope.who = getSection($rootScope.info, 'WHO');
                if ($scope.who.whoDescription == undefined || $scope.who.whoDescription === '') {
                    $scope.isEmpty = true;
                } else {
                    $scope.who.whoDescription = $sce.trustAsHtml($scope.who.whoDescription);
                }
                setActiveSection($scope, 'WHO');
            });
        }]);

    //Controller for template "/about/about-policy.html", url "/about/policy"
    upp.controller('upp.about.PolicyCtrl', ['$q', '$rootScope', '$scope', 'appi', 'config', 'aboutService', '$location', '$sce', 'translator',
        function ($q, $rootScope, $scope, appi, config, aboutService, $location, $sce, translator) {
            appi.ui.changeActualOption({moduleKey2Display: 'about', navbarKey: 'about'});
            loadRootScope(appi, aboutService, $rootScope, $scope, $q, translator).then(function () {
                $scope.policy = getSection($rootScope.info, 'POLICY');
                if ($scope.policy.policy == undefined || $scope.policy.policy === '' ) {
                    $scope.isEmpty = true;
                } else {
                    $scope.policy.policy = $sce.trustAsHtml($scope.policy.policy);
                }

                config.getType().then(function(type) {
                    if (type === 'wingu') {
                        $scope.policy.policyUpplication = translator.i18n("ABOUT.INFO.POLICY.TOS.WINGU");
                    } else {
                        $scope.policy.policyUpplication = translator.i18n("ABOUT.INFO.POLICY.TOS.UPPLICATION");
                    }
                });

                setActiveSection($scope, 'POLICY');
            });
        }]);

    //Controller for template "/about/about-where.html", url "/about/where"
    upp.controller('upp.about.LocationCtrl', ['$q', '$rootScope', '$scope', '$location', 'appi', 'aboutService', 'translator', 'urlResolver',
        function ($q, $rootScope, $scope, $location, appi, aboutService, translator, urlResolver) {
            appi.ui.changeActualOption({moduleKey2Display: 'about', navbarKey: 'about'});
            loadRootScope(appi, aboutService, $rootScope, $scope, $q, translator).then(function () {
                $scope.location = getSection($rootScope.info, 'LOCATION');
                if ($scope.location.locationMaps == undefined) {
                    $scope.isEmpty = true;
                }

                setActiveSection($scope, 'LOCATION');
            });
            $scope.openUrl = (url) => urlResolver.open(url);
        }]);

    //Controller for template "/about/about-contact.html", url "/about/contact"
    upp.controller('upp.about.ContactCtrl', ['$q', '$rootScope', '$scope', '$location', 'appi', 'aboutService', 'translator',
        function ($q, $rootScope, $scope, $location, appi, aboutService, translator) {
            appi.ui.changeActualOption({moduleKey2Display: 'about', navbarKey: 'about'});
            loadRootScope(appi, aboutService, $rootScope, $scope, $q, translator).then(function () {
                $scope.contact = getSection($rootScope.info, 'CONTACT');
                if (($scope.contact.contactPhone == undefined || $scope.contact.contactPhone === '') &&
                    ($scope.contact.contactEmail == undefined || $scope.contact.contactEmail === '')) {
                    $scope.isEmpty = true;
                }
                setActiveSection($scope, 'CONTACT');
            });
        }]);


})(upp);



// WEBPACK FOOTER //
// ./src/app/modules/about/controllers/about-controllers.js